import React from 'react'

const Header = () => (
  <header className="container">
    <div className="row">
      <div className="col-5">
        <img className="img-fluid my-3" src="assets/logo-pagoefectivo.svg" alt="Redbus - PagoEfectivo" width="136" />
      </div>
    </div>
  </header>
)

export default Header